import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, NgZone, ElementRef } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import 'rxjs/add/operator/first';

import {OwlCarousel} from 'ngx-owl-carousel';

import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';

import _ from 'lodash';

@Component({
  selector: 'app-highlight-reels-carousel',
  animations: [
    trigger('toggleHighlightReels', [
      state('open', style({
        height: '210px',
        bottom: 0,
      })),
      state('closed', style({
        height: '0',
        padding: '0',
        bottom: 0,
      })),
      transition('open => closed', [
        animate('0.4s')
      ]),
      transition('closed => open', [
        animate('0.4s')
      ]),
    ]),
  ],
  templateUrl: './highlight-reels-carousel.component.html',
  styleUrls: ['./highlight-reels-carousel.component.scss']
})
export class HighlightReelsCarouselComponent implements OnInit, OnChanges {
  @Input() highlightReelData;
  @Input() selectedMedia;
  @Output() deleteHighlightReelEmit = new EventEmitter();
  @Output() updateHighlightReelEmit = new EventEmitter();
  @Output() updateHighlightReelPositionEmit = new EventEmitter();
  @Output() cancelSortingEmit = new EventEmitter();
  @Output() openHighLightReelModalEmit = new EventEmitter();
  @ViewChild('sliderContent') sliderContent: ElementRef;

  changedHighLighReelData: any;

  accessToken: any;

  isSorted = false;
  isSortedSubmitted = false;
  highlightReelsHtml: any;
  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    private ngZone: NgZone
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnChanges(changes: SimpleChanges): void {

    const thisobject = this;
    if ( changes && changes.highlightReelData && changes.highlightReelData.currentValue) {
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        $( '#highlightReels' ).sortable({
            axis: 'x',
            connectWith: '.item',
            // containment: '.highlight-items',
            cursor: 'move',
            helper: 'clone',
            stop(event, ui) {
              thisobject.isSorted = true;
            }
        });
        this.highlightReelsHtml = $( '#highlightReels' ).html();
      });
    }
    if (changes && changes.highlightReelData && changes.highlightReelData.currentValue && changes.highlightReelData.previousValue) {
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        $( '#highlightReels' ).sortable('refresh');
        this.highlightReelsHtml = $( '#highlightReels' ).html();
      });
    }
  }

  ngOnInit() {
  }

  deleteHighlightReel(highlightReel) {
    // deleteHighlightReel
    this.memberService.deleteHighlightReel({
      Authorization: this.accessToken,
      id: highlightReel.uuid
    }).subscribe(
      (res: any) =>  {
        this.deleteHighlightReelEmit.emit(highlightReel);
      },
      (err) => {
      }
    );
  }

  empty(elem) {
    while (elem.lastChild) {
      elem.removeChild(elem.lastChild);
    }
  }

  addHighlightReelCaption(value, highlightReel) {
    // deleteHighlightReel
    const data = {
      caption: value
    };
    const formData = this.helperService.updateJsonFormat(data);
    this.memberService.postHighlightReelCaption({
      Authorization: this.accessToken,
      id: highlightReel.uuid,
      body: formData
    }).subscribe(
      (res: any) =>  {
        if ( res && res.data ) {
          this.updateHighlightReelEmit.emit(res.data);
        }
      },
      (err) => {
      }
    );
  }

  onDragCarousel(event) {}

  cancelSorting() {
    this.isSorted = false;
    this.highlightReelData = undefined;
    setTimeout(() => {
      this.cancelSortingEmit.emit(true);
    }, 1000);
  }

  saveOrderInHighlightReel() {
    if (this.isSortedSubmitted) {
      return;
    }
    if ($('.item') && $('.item').length > 0) {
      const sortedHighlightReels = [];
      $('.item').each(function( index ) {
        if ( $(this) && $(this)[0] && $(this)[0].id) {
          sortedHighlightReels.push({
            id: $(this)[0].id,
            position: index + 1
          });
        }
      });
      if (sortedHighlightReels.length > 0) {
        // Call position api highlight reels
        this.isSortedSubmitted = true;
        this.postHighlightReelPosition(sortedHighlightReels);
      }
    }
  }

  postHighlightReelPosition(sortedData) {
    // postHighlightReelPosition
    const data = {
      highlightReel: sortedData
    };
    const formData = this.helperService.updateJsonFormat(data);

    this.memberService.postHighlightReelPosition({
      Authorization: this.accessToken,
      body: formData
    }).subscribe(
      (res: any) =>  {
        if ( res && res.data ) {
          this.highlightReelsHtml = undefined;
          this.isSorted = false;
          this.isSortedSubmitted = false;
          this.updateHighlightReelPositionEmit.emit(res.data);
        }
      },
      (err) => {
      }
    );
  }

  openHighLightReelModal() {
    this.openHighLightReelModalEmit.emit(true);
  }

}
